import { RouteRecordRaw } from 'vue-router';

// 集計関連
export const aggregationRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Aggregation',
    component: () => import('@/components/pages/aggregation/index.vue'),
    path: '/aggregation',
    meta: {
      title: '集計履歴',
      requiredAuthority: 'AGGREGATIONS',
    },
  },
  {
    name: 'AggregationAdd',
    component: () => import('@/components/pages/aggregation/add/index.vue'),
    path: '/aggregation/add',
    meta: {
      title: '集計',
      requiredAuthority: [
        'RESERVE_PREPAID_TOTAL_AGGREGATIONS',
        'RESERVE_CHARGE_AGGREGATIONS',
        'RESERVE_SETTLEMENT_AGGREGATIONS',
        'RESERVE_CAMPAIGN_BREAKDOWN_AGGREGATIONS',
        'RESERVE_CAMPAIGN_AGGREGATIONS',
        'RESERVE_BULK_GRANT_AGGREGATIONS',
        'RESERVE_UNUSED_BALANCE_AGGREGATIONS',
      ],
    },
  },
];
